var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-modals-2"},[_c('vip-dialog'),_vm._v(" "),_c('confirm-again'),_vm._v(" "),_c('share'),_vm._v(" "),_c('custom-works'),_vm._v(" "),_c('customWorksSubmitted'),_vm._v(" "),_c('setUserCategories'),_vm._v(" "),_c('moveToCategory')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-087879cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EModals2.vue
// module id = null
// module chunks = 